// Miky Motorsport - cista geometrie trati (Catmull-Rom splajn + elevace terenu).
// Bez THREE/Rapier - ciste aritmeticke funkce, takze je testovatelne v Node.
// track.js tyto funkce importuje a vola, aby chovani hry zustalo identicke.

// Catmull-Rom (uniform, tension 0.5) pro jednu slozku
export function catmull(p0, p1, p2, p3, t) {
  const t2 = t * t, t3 = t2 * t;
  return 0.5 * (2 * p1 + (-p0 + p2) * t + (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 + (-p0 + 3 * p1 - 3 * p2 + p3) * t3);
}

// Mirne zvlnene kopce (deterministicke, hladke). Pouziva se pro teren (heightfield),
// silnici, scenerii i spawn. Amplitudu skaluje biom (mesto plossi nez louka).
export function elevBase(x, z) {
  return 1.7 * Math.sin(x * 0.0185) * Math.cos(z * 0.016) +
         1.15 * Math.sin((x + z) * 0.012 + 1.0) +
         0.7 * Math.cos(z * 0.024 - 0.5);
}
